const titleStyle = {
  color: "mediumGray",
  fontSize: "2",
  fontStyle: "italic",
};

const topTextStyle = {
  color: "mediumGray",
  fontWeight: "600",
  mt: "2",
};

const innerTextStyle = {
  color: "mediumGray",
  fontWeight: "600",
  mt: "1",
};

const iconTextStyle = {
  color: "mediumGray",
  fontWeight: "600",
  ml: "1",
};

const boxStyle = {
  flexGrow: 1,
};

const flexStyle = {
  flexWrap: "wrap",
  mt: 5,
};

export {
  titleStyle,
  innerTextStyle,
  topTextStyle,
  iconTextStyle,
  boxStyle,
  flexStyle,
};
